import React from "react";
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { getText } from "../libs/utils";
import {CloseIcon} from "../assets/images/icons";

const ConfirmDeleteDialog = ({ title, content, openDialog, setOpenDialog, submitHandler = () => { } }) => {

  return (
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      maxWidth="sm"
    >
      <DialogTitle component="h4" align="center" sx={{fontWeight: 600}} paddingBottom={'12px !important'}>
        {title}
        <CloseIcon
            onClick={() => setOpenDialog(false)}
            style={{
              position: "absolute",
              right: 12,
              top: 10,
              cursor: 'pointer'
            }}
          />
      </DialogTitle>
      <DialogContent>
        <Typography align="center" sx={{margin: '0 0 25px'}}>{content}</Typography>
        <Button variant="contained" fullWidth size="large" onClick={() => submitHandler()}>{getText('wantDelete')}</Button>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
